import { clone } from 'lodash';
import {
  createContext,
  FC,
  PropsWithChildren,
  useEffect,
  useState,
} from 'react';

import useUser from '../../../hooks/useUser';
import { VoiceCallAgentConfiguration } from '../interfaces';
import IVoiceCallAgentIntegrationContext from '../interfaces/VoiceCallAgentIntegrationContext';
import { getVoiceCallAgentIntegrations } from '../services';

const VoiceCallAgentIntegrationContext =
  createContext<IVoiceCallAgentIntegrationContext>({
    integrations: new Map(),
    loading: true,
    error: null,
    addIntegration(integration) {},
  });

export const VoiceCallAgentIntegrationProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const { selectedBusiness } = useUser();
  const [integrations, setIntegrations] = useState<
    IVoiceCallAgentIntegrationContext['integrations']
  >(new Map());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getVoiceCallAgentIntegrations()
      .then((integrations) =>
        setIntegrations(
          integrations.reduce((acc, val) => {
            acc.set(val.configType, val);
            return acc;
          }, new Map())
        )
      )
      .catch((error) => setError(error.message))
      .finally(() => setLoading(false));
  }, [selectedBusiness]);

  const addIntegration = (integration: VoiceCallAgentConfiguration) => {
    setIntegrations((integrations) => {
      const clonedIntegration = clone(integrations);
      clonedIntegration.set(integration.configType, integration);
      return clonedIntegration;
    });
  };

  return (
    <VoiceCallAgentIntegrationContext.Provider
      value={{
        integrations,
        loading,
        error,
        addIntegration,
      }}
      children={children}
    />
  );
};
export default VoiceCallAgentIntegrationContext;
